import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
// import USERLIST from '../_mock/users_list';
import ClanProfil from './ClanProfil';

// ----------------------------------------------------------------------

const styles = { 
  narrowCell: {
    'width': '150px',
  }
};

const TABLE_HEAD = [
  { id: 'naziv', label: 'Naziv', alignRight: false, },
  { id: 'drustvo', label: 'Drustvo', alignRight: false, },
  { id: 'mjesto', label: 'Mjesto', alignRight: false },
  { id: 'prodavac', label: 'Prodavac', alignRight: false },
  { id: 'username', label: 'Username', alignRight: false },
  { id: 'password', label: 'Password', alignRight: false },
  { id: 'mjesto', label: 'Mjesto', alignRight: false },
  { id: 'prodavac', label: 'Prodavac', alignRight: false }
];

// ----------------------------------------------------------------------korisnikid, naziv, drustvo, mjesto, prodavac, username,

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.naziv.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UsersPage() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);
  
  const [izabran, setIzabran] = useState('');

  const [orderBy, setOrderBy] = useState('naziv');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  

  return (
    <>


    </>
  );
}
